import PrivateLayout from "@/views/private/Layout";
import Dashboard from "@/views/private/Dashboard";
import SearchImages from "@/views/private/SearchImages";
import Activities from "@/views/private/user/Activities";
import Profile from "@/views/private/user/Profile";
import Logout from "@/views/private/Logout";
import About from "@/views/private/system/About";
import ReleaseNotes from "@/views/private/system/ReleaseNotes";
import Employers from "@/views/private/admin/Employers";
import Lines from "@/views/private/admin/Lines";
import Towers from "@/views/private/admin/Towers";
import Contractors from "@/views/private/admin/Contractors";
import SearchActivities from "@/views/private/admin/SearchActivities";
import Users from "@/views/private/admin/Users";
import Colleagues from "@/views/private/normal/Colleagues";
import EmployerContractors from "@/views/private/employer/Contractors";
import Upload from "@/views/private/normal/Upload";
import ContinueUpload from "@/views/private/normal/ContinueUpload";
import Uploads from "@/views/private/normal/Uploads";
import AdminUploads from "@/views/private/admin/Uploads";
import AdminImages from "@/views/private/admin/Images";
import OS from "@/views/private/server/OS";
import Models from "@/views/private/server/Models";
import Logs from "@/views/private/server/Logs";
import Images from "@/views/private/normal/Images";
import Errors from "@/views/private/server/Errors";
import Reports from "@/views/private/normal/Reports";
import ReportOnMap from "@/views/private/normal/ReportOnMap";
import AdminReports from "@/views/private/admin/Reports";
import AdminReportOnMap from "@/views/private/admin/ReportOnMap";
import BatchLogs from "@/views/private/normal/BatchLogs";
import AdminBatchLogs from "@/views/private/admin/BatchLogs";
import ReportLogs from "@/views/private/normal/ReportLogs";
import AdminReportLogs from "@/views/private/admin/ReportLogs";
import Tickets from "@/views/private/normal/Tickets";
import Ticket from "@/views/private/normal/Ticket";
import AdminTickets from "@/views/private/admin/Tickets";
import AdminTicket from "@/views/private/admin/Ticket";

const routes = [
  {
    path: "/dashboard",
    name: "PrivateLayout",
    component: PrivateLayout,
    children: [
      {
        path: "home",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          title: "dashboard"
        }
      },
      {
        path: "search-images",
        name: "SearchImages",
        component: SearchImages,
        meta: {
          title: "searchImagesToolTip"
        }
      },
      {
        path: "user/activity",
        name: "Activities",
        component: Activities,
        meta: {
          title: "activities"
        }
      },
      {
        path: "user/profile",
        name: "Profile",
        component: Profile,
        meta: {
          title: "profile"
        }
      },
      {
        path: "logout",
        name: "Logout",
        component: Logout,
        meta: {
          title: "logoutTitle"
        }
      },
      {
        path: "about",
        name: "About",
        component: About,
        meta: {
          title: "about"
        }
      },
      {
        path: "releasenotes",
        name: "ReleaseNotes",
        component: ReleaseNotes,
        meta: {
          title: "changesTitle"
        }
      },
      {
        path: "employer",
        name: "Employers",
        component: Employers,
        meta: {
          title: "employers"
        }
      },
      {
        path: "line/:id/:name",
        name: "Lines",
        component: Lines,
        meta: {
          title: "lines"
        }
      },
      {
        path: "tower/:id/:name/:employer_id/:employer_name",
        name: "Towers",
        component: Towers,
        meta: {
          title: "towers"
        }
      },
      {
        path: "contractor/:id/:name",
        name: "Contractors",
        component: Contractors,
        meta: {
          title: "contractors"
        }
      },
      {
        path: "activity/search",
        name: "SearchActivities",
        component: SearchActivities,
        meta: {
          title: "searchActivities"
        }
      },
      {
        path: "user",
        name: "Users",
        component: Users,
        meta: {
          title: "users"
        }
      },
      {
        path: "colleague",
        name: "Colleagues",
        component: Colleagues,
        meta: {
          title: "colleagues"
        }
      },
      {
        path: "employer/contractor",
        name: "EmployerContractors",
        component: EmployerContractors,
        meta: {
          title: "contractors"
        }
      },
      {
        path: "upload",
        name: "Upload",
        component: Upload,
        meta: {
          title: "uploadImages"
        }
      },
      {
        path: "continue-upload/:id",
        name: "ContinueUpload",
        component: ContinueUpload,
        meta: {
          title: "continueUpload"
        }
      },
      {
        path: "uploads",
        name: "Uploads",
        component: Uploads,
        meta: {
          title: "uploadedImages"
        }
      },
      {
        path: "admin-uploads",
        name: "AdminUploads",
        component: AdminUploads,
        meta: {
          title: "uploadedImages"
        }
      },
      {
        path: "admin-images/:id",
        name: "AdminImages",
        component: AdminImages,
        meta: {
          title: "images"
        }
      },
      {
        path: "os",
        name: "OS",
        component: OS,
        meta: {
          title: "systemStatusToolTip"
        }
      },
      {
        path: "images/:id",
        name: "Images",
        component: Images,
        meta: {
          title: "images"
        }
      },
      {
        path: "model",
        name: "Models",
        component: Models,
        meta: {
          title: "models"
        }
      },
      {
        path: "log",
        name: "Logs",
        component: Logs,
        meta: {
          title: "logs"
        }
      },
      {
        path: "error/:id/:name",
        name: "Errors",
        component: Errors,
        meta: {
          title: "modelErrors"
        }
      },
      {
        path: "report",
        name: "Reports",
        component: Reports,
        meta: {
          title: "reports"
        }
      },
      {
        path: "report-on-map/:id/:name",
        name: "ReportOnMap",
        component: ReportOnMap,
        meta: {
          title: "reportOnMap"
        }
      },
      {
        path: "admin-report",
        name: "AdminReports",
        component: AdminReports,
        meta: {
          title: "reports"
        }
      },
      {
        path: "admin-report-on-map/:id/:name",
        name: "AdminReportOnMap",
        component: AdminReportOnMap,
        meta: {
          title: "reportOnMap"
        }
      },
      {
        path: "uploads-logs/:id",
        name: "BatchLogs",
        component: BatchLogs,
        meta: {
          title: "batchImageOperations"
        }
      },
      {
        path: "admin-uploads-logs/:id",
        name: "AdminBatchLogs",
        component: AdminBatchLogs,
        meta: {
          title: "batchImageOperations"
        }
      },
      {
        path: "report-logs/:id",
        name: "ReportLogs",
        component: ReportLogs,
        meta: {
          title: "reportOperations"
        }
      },
      {
        path: "admin-report-logs/:id",
        name: "AdminReportLogs",
        component: AdminReportLogs,
        meta: {
          title: "reportOperations"
        }
      },
      {
        path: "tickets",
        name: "Tickets",
        component: Tickets,
        meta: {
          title: "support"
        }
      },
      {
        path: "tickets/:id",
        name: "Ticket",
        component: Ticket,
        meta: {
          title: "requestSupport"
        }
      },
      {
        path: "admin-tickets",
        name: "AdminTickets",
        component: AdminTickets,
        meta: {
          title: "supportCenter"
        }
      },
      {
        path: "admin-tickets/:id",
        name: "AdminTicket",
        component: AdminTicket,
        meta: {
          title: "requestSupport"
        }
      }
    ]
  }
];

export default routes;
